import { GridHeader } from './REPORT_CONFIG';

export const APP_MFA_TEMPLATE =
  '<span class="rating-${mfaRating}">' +
  ' <span class="risk-value risk-low"><img src="/assets/images/icon-meter.svg" alt="Risk Low"/>low</span>' +
  ' <span class="risk-value risk-medium"><img src="/assets/images/icon-meter.svg" alt="Risk Medium"/>medium</span>' +
  ' <span class="risk-value risk-high"><img src="/assets/images/icon-meter.svg" alt="Risk High"/>high</span>' +
  '</span>';
export const APP_BRANDSAFETY_TEMPLATE =
  '<span class="rating-${appDescriptionBrandSafetyRating}"><span class="risk-value risk-low"><img src="/assets/images/icon-meter.svg" alt="Icon Meter Low"/>low</span>' +
  '<span class="risk-value risk-medium"><img src="/assets/images/icon-meter.svg" alt="Icon Meter Medium"/>medium</span>' +
  '<span class="risk-value risk-high"><img src="/assets/images/icon-meter.svg" alt="Icon Meter High"/>high</span></span>';
export const APP_BOOLEAN_TEMPLATE =
  '<img class="icon-yes mr-1" src="/assets/images/icon-indicator-yes.svg" alt="Icon Yes"/><img class="icon-no mr-1" src="/assets/images/icon-indicator-no.svg" alt="Icon No"/>';
export const APP_BOOLEAN_TEMPLATE_REV =
  '<img class="icon-yes mr-1" src="/assets/images/icon-indicator-no-2.svg" alt="Icon No"/><img class="icon-no mr-1" src="/assets/images/icon-indicator-yes-2.svg" alt="Icon Yes"/>';

export const APP_INFO_TEMPLATE: string =
  '<div class="appTitle pl-md-4">' +
  '<div class="aptitleCont">' +
  '<img class="appIcon app-link id-${indexId} appid-${appId} device-${device} store-${appStore} region-${region} section-app-overview" ' +
  'src="${appIcon}" alt="App Icon"/>' +
  '<div class="titleCont">' +
  '<div class="title">' +
  '<a class="btn btn-link p-0 app-link id-${indexId} appid-${appId} device-${device} store-${appStore} region-${region} section-app-overview" ' +
  'href="${appInsightsLink}"' +
  'data-html="true" data-toggle="tooltip" ' +
  'entooltip="" title="${appTitle}" style="cursor: pointer;">' +
  '${appTitle}' +
  '</a>' +
  '</div>' +
  '<div class="title-cont-inner rating-${pixalateRating} device-${device} store-${appStore} freemium-${isFreemium}">' +
  '<i class="fa storeIcon fa-apple"></i>' +
  '<i class="fa storeIcon fa-android"></i>' +
  '<i data-toggle="tooltip" entooltip="" class="fa deviceIcon fa-mobile-phone cursorArrow"></i>' +
  '<i data-toggle="tooltip" entooltip="" class="fa deviceIcon fa-tablet cursorArrow"></i>' +
  '<span class="risk-label">Risk: </span>' +
  '<span class="risk-value risk-low"><img src="/assets/images/icon-meter.svg" alt="Icon Meter Low"/>low</span>' +
  '<span class="risk-value risk-medium"><img src="/assets/images/icon-meter.svg" alt="Icon Meter Medium"/>medium</span>' +
  '<span class="risk-value risk-high"><img src="/assets/images/icon-meter.svg" alt="Icon Meter High"/>high</span>' +
  '<span class="risk-value freemium-lock"><i class="fa fa-lock"></i></span>' +
  '</div>' +
  '</div>' +
  '</div>' +
  '<ul class="list-unstyled" style="left: 99px; top: 351px;">' +
  '<li>' +
  '<div>Category:</div>' +
  '<div>' +
  '<a class="btn btn-link btn-sm p-0 seller discovery-link discovery-param-category ' +
  'discovery-param-value-${category} force-select" data-html="true" ' +
  'data-toggle="tooltip" entooltip="" ' +
  'data-template="<div class=&quot;tooltip&quot; role=&quot;tooltip&quot;><div class=&quot;tooltip-arrow&quot;></div><div class=&quot;tooltip-inner email&quot;></div></div>" ' +
  'title="${category}">' +
  '${category}' +
  '</a>' +
  '</div>' +
  '</li>' +
  '<li>' +
  '<div>IAB Primary Category:</div>' +
  '<div>' +
  '<a class="btn btn-link btn-sm p-0 seller discovery-link discovery-param-iabPrimaryCategory ' +
  'discovery-param-value-${iabPrimaryCategory} force-select" data-html="true" ' +
  'data-toggle="tooltip" entooltip="" ' +
  'data-template="<div class=&quot;tooltip&quot; role=&quot;tooltip&quot;><div class=&quot;tooltip-arrow&quot;></div><div class=&quot;tooltip-inner email&quot;></div></div>" ' +
  'title="${iabPrimaryCategory}">' +
  '${iabPrimaryCategory}' +
  '</a>' +
  '</div>' +
  '</li>' +
  '<li>' +
  '<div>IAB Subcategory:</div>' +
  '<div>' +
  '<a class="btn btn-link btn-sm p-0 seller discovery-link discovery-param-iabSubCategory ' +
  'discovery-param-value-${iabSubCategory} force-select" data-html="true" ' +
  'data-toggle="tooltip" entooltip="" ' +
  'data-template="<div class=&quot;tooltip&quot; role=&quot;tooltip&quot;><div class=&quot;tooltip-arrow&quot;></div><div class=&quot;tooltip-inner email&quot;></div></div>" ' +
  'title="${iabSubCategory}">' +
  '${iabSubCategory}' +
  '</a>' +
  '</div>' +
  '</li>' +
  '<li>' +
  '<div>Bundle ID:</div>' +
  '<div>' +
  '<a class="btn btn-link btn-sm p-0 seller force-select" ' +
  'data-html="true" data-toggle="tooltip" entooltip="" ' +
  'data-template="<div class=&quot;tooltip&quot; role=&quot;tooltip&quot;><div class=&quot;tooltip-arrow&quot;></div><div class=&quot;tooltip-inner bundleId&quot;></div></div>" ' +
  'title="${bundleId}">' +
  '${bundleId}' +
  '</a>' +
  '</div>' +
  '</li>' +
  '<li>' +
  '<div>Track ID:</div>' +
  '<div>' +
  '<a class="btn btn-link btn-sm p-0 seller force-select" ' +
  'data-html="true" data-toggle="tooltip" entooltip="" title="${trackId}">' +
  '${trackId}' +
  '</a>' +
  '</div>' +
  '</li>' +
  '<li>' +
  '<div>Trusted Seller:</div>' +
  '<div>' +
  '<a class="btn btn-link btn-sm p-0 seller force-select trusted-seller-${trustedSellerId}" ' +
  'data-html="true" data-toggle="tooltip" entooltip="" ' +
  'data-template="<div class=&quot;tooltip&quot; role=&quot;tooltip&quot;><div class=&quot;tooltip-arrow&quot;></div><div class=&quot;tooltip-inner email&quot;></div></div>" ' +
  'title="${trustedSellerName}">' +
  '<img class="mr-1" alt="No Icon" onerror="this.style.opacity=0;" ' +
  'src="https://cdn.pixalate.com/sellers/icons/apn/16x16/${trustedSellerId}.jpg?cb=" width="16" height="16" alt="Icon"/>&nbsp;' +
  '${trustedSellerName}' +
  '</a>' +
  '</div>' +
  '</li>' +
  '<li>' +
  '<div>Content Rating:</div>' +
  '<div>' +
  '<a class="btn btn-link btn-sm p-0 seller force-select" data-html="true" data-toggle="tooltip" entooltip="" title="${ageGroup}">${ageGroup}</a>' +
  '</div>' +
  '</li>' +
  '<li>' +
  '<div>Developer Name:</div>' +
  '<div>' +
  '<a class="btn btn-link btn-sm p-0 seller force-select" data-html="true" data-toggle="tooltip" entooltip="" ' +
  'data-template="<div class=&quot;tooltip&quot; role=&quot;tooltip&quot;><div class=&quot;tooltip-arrow&quot;></div><div class=&quot;tooltip-inner email&quot;></div></div>" ' +
  'title="${developerName}">' +
  '${developerName}' +
  '</a>' +
  '</div>' +
  '</li>' +
  '<li>' +
  '<div>Developer Email:</div>' +
  '<div>' +
  '<a class="btn btn-link btn-sm p-0 seller force-select" data-html="true" data-toggle="tooltip" entooltip="" ' +
  'data-template="<div class=&quot;tooltip&quot; role=&quot;tooltip&quot;><div class=&quot;tooltip-arrow&quot;></div><div class=&quot;tooltip-inner email&quot;></div></div>" ' +
  'title="${developerEmail}">' +
  '${developerEmail}' +
  '</a>' +
  '</div>' +
  '</li>' +
  '<li>' +
  '<div>Developer Website:</div>' +
  '<div>' +
  '<a class="btn btn-link btn-sm p-0 seller force-select" data-html="true" data-toggle="tooltip" entooltip="" ' +
  'data-template="<div class=&quot;tooltip&quot; role=&quot;tooltip&quot;><div class=&quot;tooltip-arrow&quot;></div><div class=&quot;tooltip-inner email&quot;></div></div>" ' +
  'title="${publisherWebsite}">' +
  '${publisherWebsite}' +
  '</a>' +
  '</div>' +
  '</li>' +
  '<li>' +
  '<div>Total Apps:</div>' +
  '<div>' +
  '<a class="btn btn-link btn-sm p-0 seller force-select" data-html="true" data-toggle="tooltip" entooltip="" title="${publisherTotalApps}">${publisherTotalApps}</a>' +
  '</div>' +
  '</li>' +
  '<li>' +
  '<div>Est. Daily Reach:</div>' +
  '<div>' +
  '<a class="btn btn-link btn-sm p-0 seller force-select text-uppercase" data-html="true" data-toggle="tooltip" entooltip="" title="${dailyActiveUsersRaw}">${dailyActiveUsers}</a>' +
  '</div>' +
  '</li>' +
  '<li>' +
  '<div>Est. Monthly Reach:</div>' +
  '<div>' +
  '<a class="btn btn-link btn-sm p-0 seller force-select text-uppercase" data-html="true" data-toggle="tooltip" entooltip="" title="${monthlyActiveUsersRaw}">${monthlyActiveUsers}</a>' +
  '</div>' +
  '</li>' +
  '</ul>' +
  '</div>';

export const APP_GRID_HEADERS: Array<GridHeader> = [
  {
    label: 'Title',
    key: 'appTitle',
    sort: '',
    sortColumnKey: 'appTitle',
    hoverKey: '',
    template: APP_INFO_TEMPLATE,
    hidden: false,
    format: null
  },
  {
    label: 'PTI Rank',
    key: 'ptiRank',
    sort: 'sort-asc',
    sortColumnKey: 'ptiRank',
    hoverKey: '',
    template:
      '<div class="big-number text-uppercase"><a class="app-link id-${indexId} appid-${appId} device-${device} store-${appStore} region-${region} section-app-inventory mx-auto">${ptiRank}</a></div>',
    hidden: false,
    lockedInFreemium: true,
    format: 'pretty-number',
    tooltip: ''
  },
  {
    label: 'Est. Inventory',
    key: 'inventory',
    sort: '',
    sortColumnKey: 'inventory',
    hoverKey: '',
    template:
      '<div class="big-number text-uppercase"><a class="app-link id-${indexId} appid-${appId} device-${device} store-${appStore} region-${region} section-app-inventory mx-auto">${inventory}</a></div><div class="change-number">${totalInventoryChange}</div>',
    hidden: false,
    lockedInFreemium: true,
    format: 'big-number',
    tooltip:
      'The estimated number of monthly impressions this app makes available programmatically.'
  },
  {
    label: 'Inventory Change',
    key: 'totalInventoryChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    lockedInFreemium: true,
    format: 'percent'
  },
  {
    label: 'Viewability',
    key: 'nonGivtSivtViewability',
    sort: '',
    sortColumnKey: 'nonGivtSivtViewability',
    hoverKey: '',
    template:
      '<div class="big-number text-uppercase"><a class="app-link id-${indexId} appid-${appId} device-${device} store-${appStore} region-${region} section-app-viewability mx-auto">${nonGivtSivtViewability}</a></div><div class="change-number">${nonGivtSivtViewabilityChange}</div>',
    hidden: false,
    format: 'percent',
    tooltip: 'The average viewability for all display ad impressions in the app'
  },
  {
    label: 'Viewability Change',
    key: 'nonGivtSivtViewabilityChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'percent'
  },
  {
    label: 'Est. IVT',
    key: 'givtSivtRate',
    sort: '',
    sortColumnKey: 'givtSivtRate',
    hoverKey: '',
    template:
      '<div class="big-number text-uppercase"><a class="app-link id-${indexId} appid-${appId} device-${device} store-${appStore} region-${region} section-app-ivt mx-auto">${givtSivtRate}</a></div><div class="change-number">${givtSivtRateChange}</div>',
    hidden: false,
    format: 'percent',
    tooltip:
      'Percentage of Invalid Traffic associated with advertising transactions for the app'
  },
  {
    label: 'IVT Change',
    key: 'givtSivtRateChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'percent'
  },
  {
    label: 'Blocklisted',
    key: 'isBlacklisted',
    sort: '',
    sortColumnKey: 'isBlacklisted',
    hoverKey: '',
    template:
      '<div class="text-capitalize boolean-${isBlacklisted}">' +
      APP_BOOLEAN_TEMPLATE_REV +
      '${isBlacklisted}</div>',
    hidden: false,
    format: 'boolean',
    tooltip:
      'The app has been placed on a Pixalate high risk blocklist - contact sales for subscription details'
  },
  {
    label: 'MFA Risk',
    key: 'mfaRating',
    sort: '',
    hoverKey: '',
    sortColumnKey: 'mfaRating',
    template: APP_MFA_TEMPLATE,
    hidden: false,
    format: null,
    tooltip: `Pixalate's assessment of the risk of the app being deemed MFA, based on Pixalate's MFA detection methodology`
  },
  {
    label: 'Brand Safety Risk',
    key: 'appDescriptionBrandSafetyRating',
    sort: '',
    sortColumnKey: 'appDescriptionBrandSafetyRating',
    hoverKey: '',
    template: APP_BRANDSAFETY_TEMPLATE,
    hidden: false,
    lockedInFreemium: false,
    format: null,
    tooltip:
      'Risk factors to advertiser Brand Safety broken down by both in-app content such as images, and descriptive text about the app'
  },
  {
    label: 'Incentivized App',
    key: 'isIncentivizedApp',
    sort: '',
    sortColumnKey: 'isIncentivizedApp',
    hoverKey: '',
    template:
      '<div class="text-capitalize boolean-${isIncentivizedApp}">' +
      APP_BOOLEAN_TEMPLATE +
      '${isIncentivizedApp}</div>',
    hidden: false,
    format: 'boolean',
    tooltip: 'Indicates if the app is an incentivized app'
  },
  {
    label: 'User Generated Content',
    key: 'hasUserGeneratedContent',
    sort: '',
    sortColumnKey: 'hasUserGeneratedContent',
    hoverKey: '',
    template:
      '<div class="text-capitalize boolean-${hasUserGeneratedContent}">' +
      APP_BOOLEAN_TEMPLATE +
      '${hasUserGeneratedContent}</div>',
    hidden: false,
    format: 'boolean',
    tooltip: 'Indicates if the app has user generated content'
  },
  {
    label: 'App-ads.txt Detected',
    key: 'hasAdsTxt',
    sort: '',
    sortColumnKey: 'hasAdsTxt',
    hoverKey: '',
    template:
      '<div class="text-capitalize boolean-${hasAdsTxt}">' +
      APP_BOOLEAN_TEMPLATE +
      '${hasAdsTxt}</div>',
    hidden: false,
    format: 'boolean'
  },
  {
    label: 'App Icon',
    key: 'appIcon',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Risk',
    key: 'pixalateRating',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Device',
    key: 'device',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'App Store',
    key: 'appStore',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Category',
    key: 'category',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'IAB Primary Category',
    key: 'iabPrimaryCategory',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'IAB Subcategory',
    key: 'iabSubCategory',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Bundle ID',
    key: 'bundleId',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Track ID',
    key: 'trackId',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Trusted Seller ID',
    key: 'trustedSellerId',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Trusted Seller Name',
    key: 'trustedSellerName',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Age Group',
    key: 'ageGroup',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Developer Name',
    key: 'developerName',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Developer Email',
    key: 'developerEmail',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Developer Website',
    key: 'publisherWebsite',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Developer Total Apps',
    key: 'publisherTotalApps',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Est. Daily Reach',
    key: 'dailyActiveUsers',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'big-number-no-decimal'
  },
  {
    label: 'Daily Active Users Raw',
    key: 'dailyActiveUsersRaw',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'pretty-number'
  },
  {
    label: 'Est. Monthly Reach',
    key: 'monthlyActiveUsers',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'big-number-no-decimal'
  },
  {
    label: 'Monthly Active Users Raw',
    key: 'monthlyActiveUsersRaw',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'pretty-number'
  },
  {
    label: 'App ID',
    key: 'appId',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Region',
    key: 'region',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  }
];
